import { Descriptions, Divider, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as permissionKind from '../../../../../shared/permissions';
// eslint-disable-next-line max-len
import { type SimpleVehicleManagementModuleWithPermissionsSpecsFragment } from '../../../../api/fragments/SimpleVehicleManagementModuleWithPermissionsSpecs';
import ConsolePageWithHeader from '../../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../../utilities/hasPermissions';
import useFormattedSimpleVersioning from '../../../../utilities/useFormattedSimpleVersioning';
import SimpleVehicleManagementModuleActions from './SimpleVehicleManagementModuleActions';
import SimpleVehicleManagementModuleFooter from './SimpleVehicleManagementModuleFooter';
import SimpleVehicleManagementModuleInnerPage from './SimpleVehicleManagementModuleInnerPage';

export type SimpleVehicleManagementModuleProps = { module: SimpleVehicleManagementModuleWithPermissionsSpecsFragment };

const SimpleVehicleManagementModulePage = ({ module }: SimpleVehicleManagementModuleProps) => {
    const { t } = useTranslation(['simpleVehicleManagementDetail']);
    const navigate = useNavigate();

    const { updated, offset } = useFormattedSimpleVersioning({
        versioning: module.versioning,
        timeZone: module.company.timeZone,
    });
    const screens = Grid.useBreakpoint();

    const permissions = {
        hasDeletePermission: hasPermissions(module.permissions, [permissionKind.deleteModule]),
    };

    const content = (
        <Descriptions column={{ xs: 1, md: 2 }} bordered>
            <Descriptions.Item label={t('simpleVehicleManagementDetail:content.displayName')}>
                {module.displayName}
            </Descriptions.Item>
            <Descriptions.Item label={t('simpleVehicleManagementDetail:content.company')}>
                {module.company.displayName}
            </Descriptions.Item>
            <Descriptions.Item {...t('common:fields.updated', { returnObjects: true, offset })}>
                {updated}
            </Descriptions.Item>
        </Descriptions>
    );

    return (
        <ConsolePageWithHeader
            content={content}
            extra={<SimpleVehicleManagementModuleActions module={module} permissions={permissions} />}
            footer={[<SimpleVehicleManagementModuleFooter />]}
            onBack={() => navigate('/admin/system/modules')}
            title={
                screens.md ? t('simpleVehicleManagementDetail:title', { name: module.displayName }) : module.displayName
            }
        >
            <Divider>{t('simpleVehicleManagementDetail:dividers.mainDetails')}</Divider>
            <SimpleVehicleManagementModuleInnerPage module={module} />
        </ConsolePageWithHeader>
    );
};

export default SimpleVehicleManagementModulePage;
